<template>
  <div class="activity-edit">
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="content"
      ></el-page-header>
    </div>
    <el-card class="content mt20 bbb">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <!-- <el-form-item :label="$t('activityList.time')" prop="start_time">
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            :range-separator="$t('to')"
            :start-placeholder="$t('start_date')"
            :end-placeholder="$t('end_date')"
          >
          </el-date-picker>
        </el-form-item> -->
        <el-form-item :label="$t('activityList.apply_time')" prop="apply_start">
          <el-date-picker
            v-model="apply_dateValue"
            type="daterange"
            :range-separator="$t('to')"
            :start-placeholder="$t('start_date')"
            :end-placeholder="$t('end_date')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('activityList.title')" prop="title">
          <el-input
            maxlength="30"
            show-word-limit
            v-model="ruleForm.title"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('activityList.subtitle')" prop="subtitle">
          <el-input
            maxlength="30"
            show-word-limit
            v-model="ruleForm.subtitle"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('activityList.type')" prop="type">
          <el-select v-model="ruleForm.type" :placeholder="$t('please_select')">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('activityList.active')" prop="active">
          <el-radio-group v-model="ruleForm.active">
            <el-radio :label="0">{{ $t('activityList.active0') }}</el-radio>
            <el-radio :label="1">{{ $t('activityList.active1') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('activityList.total_num')" prop="total_num">
          <el-input
            @input="
              (res) => {
                this.ruleForm.total_num = +res;
              }
            "
            @mousewheel.native.prevent
            @DOMMouseScroll.native.prevent
            type="number"
            :value="ruleForm.total_num"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('activityList.order')" prop="order">
          <el-input
            @input="
              (res) => {
                this.ruleForm.order = +res;
              }
            "
            @mousewheel.native.prevent
            @DOMMouseScroll.native.prevent
            type="number"
            placeholder="정렬순이 높은 건이 우선 노출됩니다."
            v-model="ruleForm.order"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('activityList.cover')" prop="cover">
          <upload-img
            :limitMax="1"
            :file-list="ruleForm.cover"
            @changeImgList="changeImgList"
          ></upload-img>
          <p class="img-guide">
            최대 파일 크기: 300M, 이미지 최적 사이즈: 920px * 920px(1:1 비율
            권장)
          </p>
        </el-form-item>
        <el-form-item :label="$t('activityList.content')" prop="content">
          <div v-if="load">
            <SummerNote
              :id="'summernote' + new Date().getTime()"
              v-model="ruleForm.content"
            />
          </div>
        </el-form-item>
        <el-form-item :label="$t('activityList.isbn_code')" prop="isbn_code">
          <el-radio-group v-model="ruleForm.isbn_code">
            <el-radio :label="0">{{ $t('activityList.isbn_code0') }}</el-radio>
            <el-radio :label="1">{{ $t('activityList.isbn_code1') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.isbn_code === 1"
          :label="$t('activityList.isbn_content')"
          prop="isbn_content"
        >
          <el-input v-model="ruleForm.isbn_content"></el-input>
        </el-form-item>
        <el-form-item :label="$t('activityList.apply_type')" prop="apply_type">
          <el-radio-group v-model="ruleForm.apply_type">
            <el-radio :label="0">{{ $t('activityList.apply_type0') }}</el-radio>
            <el-radio :label="1">{{ $t('activityList.apply_type1') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.apply_type === 1"
          :label="$t('activityList.external_link')"
          prop="external_link"
        >
          <el-input v-model="ruleForm.external_link"></el-input>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.apply_type === 0"
          :label="$t('activityList.is_pay')"
          prop="is_pay"
        >
          <el-radio-group v-model="ruleForm.is_pay">
            <el-radio :label="0">{{ $t('activityList.is_pay0') }}</el-radio>
            <el-radio :label="1">{{ $t('activityList.is_pay1') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.apply_type === 0 && ruleForm.is_pay === 1"
          :label="$t('activityList.is_deduction')"
          prop="is_deduction"
        >
          <el-radio-group v-model="ruleForm.is_deduction">
            <el-radio :label="false">{{
              $t('activityList.is_deduction0')
            }}</el-radio>
            <el-radio :label="true">{{
              $t('activityList.is_deduction1')
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.apply_type === 0 && ruleForm.is_pay === 1"
          :label="$t('activityList.pay_type')"
          prop="pay_type"
        >
          <el-radio-group v-model="ruleForm.pay_type">
            <el-select
              v-model="ruleForm.pay_type"
              :placeholder="$t('please_select')"
            >
              <el-option
                v-for="item in pay_type_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.apply_type === 0 && ruleForm.is_pay === 1"
          :label="$t('activityList.price')"
          prop="price"
        >
          <el-input
            @input="
              (res) => {
                this.ruleForm.price = +res;
              }
            "
            type="number"
            min="0"
            :value="ruleForm.price"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.apply_type === 0 && ruleForm.is_pay === 1"
          :label="$t('activityList.max_purchase_limit')"
          prop="max_purchase_limit"
        >
          <el-input
            @input="
              (res) => {
                this.ruleForm.max_purchase_limit = +res;
              }
            "
            type="number"
            min="1"
            :value="ruleForm.max_purchase_limit"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.apply_type === 0 && ruleForm.is_pay === 1"
          :label="$t('activityList.option')"
          prop="option"
        >
          <el-input v-model="ruleForm.option"></el-input>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.apply_type === 0 && ruleForm.is_pay === 1"
          :label="$t('activityList.option_desc')"
          prop="option_desc"
        >
          <el-input v-model="ruleForm.option_desc"></el-input>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.apply_type === 0 && ruleForm.is_pay === 1"
          :label="$t('activityList.refund_desc')"
          prop="refund_desc"
        >
          <SummerNote
            :id="'summernote1' + new Date().getTime()"
            v-model="ruleForm.refund_desc"
          />
        </el-form-item>
      </el-form>
      <el-dropdown class="left-btn" @command="handleCommand">
        <el-button type="primary">
          review<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="1">pc</el-dropdown-item>
          <el-dropdown-item :command="2">ipad</el-dropdown-item>
          <el-dropdown-item :command="3">phone</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button class="btn" type="primary" @click="submitForm('ruleForm')">{{
        $t('btnTip.submit')
      }}</el-button>
    </el-card>
    <el-dialog
      :visible.sync="review"
      :append-to-body="false"
      :width="type === 1 ? '1200px' : type === 2 ? '820px' : '400px'"
      :height="type === 1 ? '1080px' : type === 2 ? '1024px' : '640px'"
    >
      <Review style="color:#000" :ruleForm="ruleForm" :type="type" />
    </el-dialog>
  </div>
</template>
<script>
import time from '@/utils/timeFormat';
import uploadImg from '@/components/uploadImg';
import SummerNote from '@/components/summernote';
import Review from '@/components/review';
import { activityDetail, addActivity, editActivity } from '@/api/api';
export default {
  name: 'editActivity',
  data() {
    var validateMaxLimit = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('readList').max_purchase_limit));
      } else if (value > this.ruleForm.total_num) {
        callback(
          new Error('최대 구매 가능한 수량이 모집 인원을 초과했습니다.')
        );
      } else {
        callback();
      }
    };
    return {
      time,
      review: false,
      type: 1,
      ruleForm: {
        // start_time: "",
        // end_time: "",
        apply_start: '',
        apply_end: '',
        title: '',
        subtitle: '',
        content: '',
        cover: '',
        type: '',
        active: 0,
        total_num: '',
        order: 0,
        apply_type: 0,
        external_link: '',
        is_pay: 0,
        is_deduction: false,
        option: '',
        option_desc: '',
        price: 0,
        max_purchase_limit: 1,
        refund_desc: '',
        pay_type: 0,
        isbn_code: 0,
        isbn_content: '',
      },
      rules: {
        // start_time: [
        //   {
        //     required: true,
        //     message: this.$t("activityList").time,
        //     trigger: "blur",
        //   },
        // ],
        apply_start: [
          {
            required: true,
            message: this.$t('activityList').apply_time,
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: this.$t('activityList').title,
            trigger: 'blur',
          },
        ],
        subtitle: [
          {
            required: true,
            message: this.$t('activityList').subtitle,
            trigger: 'blur',
          },
        ],
        content: [
          {
            required: true,
            message: this.$t('activityList').content,
            trigger: 'blur',
          },
        ],
        cover: [
          {
            required: true,
            message: this.$t('activityList').cover,
            trigger: 'blur',
          },
        ],
        type: [
          {
            required: true,
            message: this.$t('activityList').type,
            trigger: 'blur',
          },
        ],
        active: [
          {
            required: true,
            message: this.$t('activityList').active,
            trigger: 'blur',
          },
        ],
        total_num: [
          {
            required: true,
            message: this.$t('activityList').total_num,
            trigger: 'blur',
          },
        ],
        order: [
          {
            required: true,
            message: this.$t('activityList').order,
            trigger: 'blur',
          },
        ],
        isbn_code: [
          {
            required: true,
            message: this.$t('activityList').have_ISBN,
            trigger: 'blur',
          },
        ],
        isbn_content: [
          {
            required: false,
            message: 'ISBN을 입력해 주세요.',
            trigger: 'blur',
          },
        ],
        apply_type: [
          {
            required: true,
            message: this.$t('activityList').apply_type,
            trigger: 'blur',
          },
        ],
        external_link: [
          {
            required: true,
            message: this.$t('activityList').external_link,
            trigger: 'blur',
          },
        ],
        is_pay: [
          {
            required: true,
            message: this.$t('activityList').is_pay,
            trigger: 'blur',
          },
        ],
        is_deduction: [
          {
            required: true,
            message: this.$t('activityList').is_deduction,
            trigger: 'blur',
          },
        ],
        pay_type: [
          {
            required: true,
            message: this.$t('activityList').pay_type,
            trigger: 'blur',
          },
        ],
        option: [
          {
            required: true,
            message: this.$t('activityList').option,
            trigger: 'blur',
          },
        ],
        option_desc: [
          {
            required: true,
            message: this.$t('activityList').option_desc,
            trigger: 'blur',
          },
        ],
        price: [
          {
            required: true,
            message: this.$t('activityList').price,
            trigger: 'blur',
          },
        ],
        max_purchase_limit: [
          {
            required: true,
            validator: validateMaxLimit,
            trigger: 'blur',
          },
        ],
        refund_desc: [
          {
            required: true,
            message: this.$t('activityList').refund_desc,
            trigger: 'blur',
          },
        ],
      },
      dateValue: '',
      apply_dateValue: '',
      options: [
        { label: this.$t('activityList.type1'), value: 2 },
        { label: this.$t('activityList.type2'), value: 1 },
      ],
      pay_type_options: [
        { label: this.$t('activityList.pay_type0'), value: 0 },
        { label: this.$t('activityList.pay_type1'), value: 1 },
        { label: this.$t('activityList.pay_type2'), value: 2 },
      ],
      load: false,
    };
  },
  components: {
    SummerNote,
    uploadImg,
    Review,
  },
  computed: {
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    },
    content() {
      return this.id === undefined
        ? this.$t('btnTip').add
        : this.$t('btnTip').edit;
    },
  },
  watch: {
    'ruleForm.apply_type'() {
      this.rules.external_link[0].required = this.ruleForm.apply_type
        ? true
        : false;
      this.rules.is_pay[0].required = this.ruleForm.apply_type ? false : true;
      this.rules.is_deduction[0].required = this.ruleForm.apply_type
        ? false
        : true;
      this.rules.option[0].required = this.ruleForm.apply_type ? false : true;
      this.rules.option_desc[0].required = this.ruleForm.apply_type
        ? false
        : true;
      this.rules.price[0].required = this.ruleForm.apply_type ? false : true;
      this.rules.refund_desc[0].required = this.ruleForm.apply_type
        ? false
        : true;
      this.rules.pay_type[0].required = this.ruleForm.apply_type ? false : true;
    },
    'ruleForm.is_pay'() {
      this.rules.is_deduction[0].required = this.ruleForm.is_pay ? true : false;
      this.rules.option[0].required = this.ruleForm.is_pay ? true : false;
      this.rules.option_desc[0].required = this.ruleForm.is_pay ? true : false;
      this.rules.price[0].required = this.ruleForm.is_pay ? true : false;
      this.rules.refund_desc[0].required = this.ruleForm.is_pay ? true : false;
      this.rules.pay_type[0].required = this.ruleForm.is_pay ? true : false;
    },
    'ruleForm.isbn_code'() {
      this.rules.isbn_content[0].required = this.ruleForm.isbn_code
        ? true
        : false;
    },
    // dateValue() {
    //   if (this.dateValue === null) {
    //     this.ruleForm.start_time = "";
    //     this.ruleForm.end_time = "";
    //     return;
    //   }
    //   this.ruleForm.start_time = time.currentTime(this.dateValue[0])+' 00:00:00';
    //   this.ruleForm.end_time = time.currentTime(this.dateValue[1])+' 23:59:59';
    // },
    apply_dateValue() {
      if (this.apply_dateValue === null) {
        this.ruleForm.apply_start = '';
        this.ruleForm.apply_end = '';
        return;
      }
      this.ruleForm.apply_start = time.currentTime(this.apply_dateValue[0]);
      this.ruleForm.apply_end = time.currentTime(this.apply_dateValue[1]);
    },
  },
  methods: {
    handleCommand(e) {
      this.type = e;
      this.review = true;
    },
    changeImgList(arr) {
      if (arr.length === 0) {
        this.ruleForm.cover = '';
      } else {
        this.ruleForm.cover = arr[0];
      }
    },
    async submitForm(formName) {
      await this.$refs[formName].validate();
      let ruleForm = { ...this.ruleForm };
      if (ruleForm.apply_type === 0) {
        delete ruleForm.external_link;
        if (ruleForm.is_pay === 0) {
          delete ruleForm.option;
          delete ruleForm.is_deduction;
          delete ruleForm.option_desc;
          delete ruleForm.price;
          delete ruleForm.refund_desc;
          delete ruleForm.pay_type;
        }
      }
      if (ruleForm.apply_type === 1) {
        delete ruleForm.is_pay;
        delete ruleForm.option;
        delete ruleForm.is_deduction;
        delete ruleForm.option_desc;
        delete ruleForm.price;
        delete ruleForm.refund_desc;
        delete ruleForm.pay_type;
      }
      if (ruleForm.isbn_code === 0) {
        delete ruleForm.isbn_content;
      }
      if (this.id === undefined) {
        await addActivity(ruleForm);
      } else {
        delete ruleForm.create_time;
        delete ruleForm.update_time;
        await editActivity(ruleForm);
      }
      this.$router.go(-1);
    },
    async get_info() {
      const information = await activityDetail(this.id);
      // this.dateValue = [
      //   new Date(information.start_time),
      //   new Date(information.end_time),
      // ];
      this.apply_dateValue = [
        new Date(information.apply_start),
        new Date(information.apply_end),
      ];
      this.ruleForm = { ...information };
      this.load = true;
    },
  },
  async created() {
    if (this.id === undefined) {
      this.load = true;
      return;
    }
    this.get_info();
  },
};
</script>
<style land="scss" scoped>
.el-date-editor {
  margin-right: 10px;
}
.bbb {
  position: relative;
  padding-bottom: 50px;
}
.bbb .btn {
  position: absolute;
  bottom: 10px;
  right: 20px;
}
.left-btn {
  position: absolute;
  bottom: 10px;
  left: 20px;
}

.img-guide {
  color: #808080;
}
</style>
